import { PersonType } from "./Fields/types";
import { mergeDeep } from "../../../utils/Helper";
import { validations } from "./AlertSimple";

export const defaultState = () => ({
  alert: {
    personType: PersonType.All,
    processes: 'CompliaceEvent'
  },
  fields: {
    readonly: {},
    errors: {}
  },
  buttons: {
    confirm: {
      loading: false
    }
  }
})

export const alertSimpleReducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE_FIELDS':
      return processChangeFields(state, action.fields);
    case 'UPDATE_BUTTONS':
      return processUpdateButtons(state, action.buttons);
    case 'FORCE_UPDATE_VALIDATION':
        return forceUpdateValidation(state, action);
    default:
      return state;
  }
}

function processChangeFields(state, fields) {
  const errors = Object.keys(fields)
    .reduce((f, name) => {
      f[name] = undefined;
      return f;
    }, {});

    return mergeDeep(
      { ...state },
      {
        alert: {
          ...fields
        },
        fields: {
          errors
        }
      }
    );
}

export function validateForm(state) {
  const {alert, fields} = state;
  
	const errors = {};

  Object.entries(validations(alert)).forEach((entry) => {
    const [name, value] = entry;

		if (!fields.readonly[name]) {
      if (value.empty) {
        if (alert[name] == undefined || alert[name] === '') {
          errors[name] = 'Required field'
        }
        else if (value.autosuggestId && alert[value.autosuggestId] == undefined) {
          errors[name] = 'Must select a value from list'
        }
      }
		}
  })

  // has Errors only add errors to state
  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
}

export function forceUpdateValidation(state, {errors}) {
  return {
    ...state,
    fields: {
      ...state.fields,
      errors
    }
  }
}

export function processUpdateButtons(state, buttons) {
  return mergeDeep(
    {...state},
    {
      buttons
    }
  )
}

export const initialize = (props) => {

	return (initialState) => {
    return {
      ...initialState
    }
  }
}